// import on from '../util/elements/on'

export default function (Site, $) {
  Site.widget('checkout-location', {
    _create () {
      this.checkoutLocation()
    },
    checkoutLocation () {
      if(document.querySelectorAll('input[name="_pickup_location"]').length) {
        const location = this.element[0].dataset.location
        $('input[name="_pickup_location"]').on('change', (e) => {
          if (location === e.currentTarget.value) {
            this.element[0].classList.remove('closed')
          } else {
            this.element[0].classList.add('closed')
          }
        })
      }
    }
  })
}
